// Esquemas seguros para los `src`/`href` que salen de DATOS (respuesta de la API o campos
// libres del panel). Un `javascript:` en el `src` de un iframe SE EJECUTA heredando el
// origen del documento que lo embebe, y con los JWT en localStorage (config/constants.js)
// y sin CSP eso es toma de cuenta. El esquema se comprueba PARSEANDO la URL, nunca
// comparando strings: " javascript:" o "java\tscript:" pasan cualquier comparación
// ingenua y el navegador los normaliza igual.

/**
 * Parsea `raw` y lo devuelve solo si es una URL https. Base compartida de los
 * filtros de abajo; no se exporta.
 *
 * @param {unknown} raw
 * @returns {URL|null}
 */
function parseHttpsUrl(raw) {
  if (!raw) return null;
  try {
    const url = new URL(String(raw), window.location.origin);
    return url.protocol === "https:" ? url : null;
  } catch {
    return null;
  }
}

/**
 * URL apta para el `src` de un iframe de video (YouTube/Vimeo).
 *
 * Además de https, tiene que ser de OTRO origen: un video de FAQ nunca es del
 * propio panel. Sin esta regla, "www.youtube.com/embed/x" (sin esquema) se
 * resuelve contra el origen de la app y el iframe termina embebiendo la propia
 * SPA; y una ruta relativa pasa por la misma puerta.
 *
 * @param {unknown} raw valor crudo del dato (p. ej. `faq.videoUrl`)
 * @returns {string|null} href absoluto https de otro origen, o `null`
 */
export function safeEmbedUrl(raw) {
  const url = parseHttpsUrl(raw);
  if (!url || url.origin === window.location.origin) return null;
  return url.href;
}

/**
 * URL apta para el `src` de una `<img>`: data URL de imagen (así la sube el panel, con
 * FileReader) o https. El SVG queda fuera a propósito: es el único formato de imagen que
 * puede traer scripts.
 *
 * @param {unknown} raw valor crudo del dato (p. ej. `faq.image`)
 * @returns {string|null}
 */
export function safeImageSrc(raw) {
  if (!raw) return null;
  const value = String(raw).trim();
  if (/^data:image\/(png|jpe?g|gif|webp|avif);base64,/i.test(value)) return value;
  return parseHttpsUrl(value)?.href ?? null;
}

/**
 * URL apta para un ARCHIVO que el panel abre o previsualiza (documento del S3, blob:
 * propio). Se aceptan http/https/blob porque el objetivo acá es cerrar los esquemas
 * EJECUTABLES (`javascript:`, `data:`, `vbscript:`); `http:` se deja pasar para no romper
 * los entornos de QA donde el proxy de archivos puede no tener TLS.
 *
 * @param {unknown} raw valor crudo del dato (p. ej. `user.driveLicense`, `pickup.pdfUrl`)
 * @returns {string|null}
 */
export function safeFileUrl(raw) {
  if (!raw) return null;
  try {
    const url = new URL(String(raw), window.location.origin);
    return ["https:", "http:", "blob:"].includes(url.protocol) ? url.href : null;
  } catch {
    return null;
  }
}
